export default "__VITE_ASSET__oIxLuTdh__"